import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Form, Input } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import aocLogo from "../../assets/images/AOC_LOGOTIP HORITZ.png";

import { FormValues } from "./interfaces";

import { useAuthContext } from "../../providers";

import { emailRules, passwordRules } from "./utils";

import { PATH_ROUTES } from "../../router/routes";

import styles from "./LoginForm.module.css";

const LoginForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<FormValues>();
  const { login } = useAuthContext();

  const [isInvalidCredentials, setIsInvalidCredentials] = useState(false);
  const [validError, setValidError] = useState<string | null>(null);

  const onSubmitLogin = async () => {
    try {
      const formValues = await form.validateFields();

      try {
        await login(formValues.email, formValues.password);
        navigate(PATH_ROUTES.home);
      } catch (error) {
        setIsInvalidCredentials(true);
      }
    } catch (error) {
      setIsInvalidCredentials(true);
    }
  };

  const resetInvalidCredentials = () => {
    setIsInvalidCredentials(false);
    setValidError(null);
  };

  return (
    <section className={styles.formContainer}>
      <img className={styles.logo} src={aocLogo} alt="Diputacio Logo" />
      <Form className={styles.form} form={form} layout="vertical">
        <header className={styles.formHeader}>
          <h3 className="head3">Plataforma d'anonimització automàtica</h3>
          <h4 className="lg normal">Introdueix les teves credencials per a accedir</h4>
        </header>
        <section className={styles.formContent}>
          <Form.Item
            required={false} // Para eliminar el asterisco
            name="email"
            rules={emailRules}
            label="Correu"
            hasFeedback
            className="customFormItem login"
          >
            <Input
              name="email"
              onChange={resetInvalidCredentials}
              prefix={<MailOutlined />}
              placeholder="Introdueix el teu correu"
            />
          </Form.Item>
          <Form.Item
            required={false} // Para eliminar el asterisco
            name="password"
            rules={passwordRules}
            label="Contrasenya"
            hasFeedback
            className="customFormItem login"
          >
            <Input.Password
              name="password"
              onChange={resetInvalidCredentials}
              prefix={<LockOutlined />}
              placeholder="Introdueix la teva contrasenya"
            />
          </Form.Item>
          {isInvalidCredentials && (
            <Alert
              message={<h4 className="base strong">Error d'inici de sessió</h4>}
              description="L'usuari o la contrasenya no són correctes. Si us plau, torna a intentar-ho."
              type="error"
            />
          )}
          {validError && (
            <Alert
              message={<h4 className="base strong">Error d'autenticació amb VALId</h4>}
              description={validError}
              type="error"
              closable
              onClose={() => setValidError(null)}
            />
          )}
        </section>
        <Button onClick={onSubmitLogin} type="primary" htmlType="submit" block>
          Inicia sessió
        </Button>
      </Form>
    </section>
  );
};
export default LoginForm;
